<select #select [size]="size" (change)="onChange($event)" (blur)="onBlur($event)">
    <option *ngFor="let elt of data" [value]="elt.label">{{ elt.label }}</option>
</select>
